import React from 'react';
import { css } from '@emotion/react';

interface SpinLoadingProps {
  children: React.ReactElement;
  isLoading: boolean;
  absolute?: boolean;
}

export const SpinLoading = (props: SpinLoadingProps) => {
  const { children, isLoading, absolute } = props;
  return (
    <div css={style} className="loading-wrapper">
      {children}
      {isLoading && <div className={`${absolute ? 'spin-absolute' : 'spin-fixed'} loading-spin`} />}
    </div>
  );
};

const style = css`
  .spin-absolute {
    position: absolute;
  }

  .spin-absolute {
    position: fixed;
  }

  .loading-spin {
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #6e6e6e59;
    z-index: 9999;
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loading-spin::after {
    content: '';
    display: block;
    position: absolute;
    right: 49%;
    top: 45%;
    width: 40px;
    height: 40px;
    border-style: solid;
    border-color: #6e6e6e;
    border-top-color: transparent;
    border-width: 4px;
    border-radius: 50%;
    -webkit-animation: spin 0.8s linear infinite;
    animation: spin 0.8s linear infinite;
  }
`;
